/**
 * @file 主要做一些全局初始化的工作
 */
import { Layout } from '@web3/base-components';
import {
  AppVersionProvider,
  UserStatusProvider,
  RegisterProvider,
  SwitchWalletProvider,
} from '@/components';
import { addReqInterceptor, isTestnet, isProduct } from '@web3/base-utils';
import { useEffect } from 'react';

import '@web3/base-css';
import '@/assets/css/index.css';

export default function MyApp({ Component, pageProps }) {
  useEffect(() => {
    addReqInterceptor((params) => {
      return {
        ...params,
        activityCode: isProduct ? 410 : isTestnet ? 227 : 1715919160976,
      };
    });
  }, []);
  return (
    <Layout {...pageProps} noSeoHead={!pageProps.usedDynamicSeo}>
      <AppVersionProvider>
        <SwitchWalletProvider>
          <UserStatusProvider>
            <RegisterProvider>
              <Component {...pageProps} />
            </RegisterProvider>
          </UserStatusProvider>
        </SwitchWalletProvider>
      </AppVersionProvider>
    </Layout>
  );
}
